import gql from 'graphql-tag'

export const GET_ALERT = gql`
  query {
    alert @client {
      open,
      message,
      type
    }
  }
`

export const SET_ALERT = gql`
  mutation setAlert($alert: Alert) {
    setAlert(alert: $alert) @client
  }
`

export const CLEAR_ALERT = gql`
  mutation clearAlert {
    clearAlert @client
  }
`
